import { workingHourConstants } from '../constant/workingHour.constants';

// The initial state of the App
export const initialState = {
    worklog: {
        id: 1,
        projectId: '',
        projectCode: '',
        projectName: '',
        businessFrom: '',
        businessTo: '',
        normalTime: '',
        overtime: '',
        overtimeType: '',
        remark: '',
        site: '',
        shift: '',
        status: '',
        approverId: ''
    },
    dataWorkingHour: [],
    errorCode: '',
    successCode: '',
    isLoading: false
};

const workingHourReducer = (state = initialState, action) => {
    switch (action.type) {
        case workingHourConstants.GET_SUCCESS:
            return {
                ...state,
                dataWorkingHour: action.workLog,
                isLoading: false
            };

        case workingHourConstants.ADD_SUCCESS:
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };

        case workingHourConstants.ADD_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };

        case workingHourConstants.UPDATE_SUCCESS:
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };

        case workingHourConstants.CLEAR_SUCCESS_CODE:
            return {
                ...state,
                successCode: '',
            };

        case workingHourConstants.UPDATE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };

        case workingHourConstants.DELETE_SUCCESS:
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };

        case workingHourConstants.DELETE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };

        case workingHourConstants.GETAPPROVAL_SUCCESS:
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };

        case workingHourConstants.GETAPPROVAL_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };
        default:
            return state;
    }
};

export default workingHourReducer;
